import { CarouselManager } from "../utils/carouselManager";

class GHero extends HTMLElement {
  constructor() {
    super();

    this.splideEl = this.querySelector(".splide");
  }

  async connectedCallback() {
    if(this.splideEl) {
      this.slidePromise = this._initSlider();
      window.addEventListener("load", this._enableAutoplay.bind(this));
    }
  }

  async _initSlider() {
      const pagination = this.dataset.pagination === "true";
      const interval = parseInt(this.dataset.autoplayDelay) || 3000;
      this.splide = await CarouselManager.create(
        this.splideEl,
        {
          type: "fade",
          fixedWidth: "100%",
          autoHeight: true,
          arrows: false,
          pagination: pagination,
          rewind: true,
          autoplay: 'pause',
          interval: interval
        },
        true
      );
      return;
  }

  _enableAutoplay() {
    this.slidePromise.then(() => {
      this.splide.Components.Autoplay.play();
    });
  }
}

customElements.define("g-hero", GHero);
